import React, { useState, forwardRef } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import StarRating from '../../../molecules/shared/starRating/StarRating';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import ReviewItem from '../../../molecules/system/reviewItem/ReviewItem';

const Reviews = forwardRef(({ sections, t, openModalForm }, ref) => {
  const general = sections.find((el) => el.type === 'general');
  const ratesInit = sections.find((el) => el.type === 'ratings').componentData;
  const [rates, setRates] = useState(ratesInit.slice(0, 3));

  const halfLength = Math.ceil(general.componentData.length / 2);
  const firstHalf = general.componentData.slice(0, halfLength);
  const secondHalf = general.componentData.slice(halfLength);
  return (
    <div ref={ref} className="flex">
      <div className="flex w-full flex-col flex-1 lg:mx-auto max-w-6xl my-10 gap-10">
        <div className="flex flex-col bg-primary-800 mx-8 rounded-[32px] px-5 py-8 md:p-10 lg:p-20 gap-10">
          <Stack className="flex flex-1 max-w-md">
            <Typography
              fontVariant="h8"
              textAlign="left"
              className="!text-secondary-400"
            >
              {general.shortTitle}
            </Typography>
            <Typography
              as="h2"
              fontVariant="h4"
              textAlign="left"
              className="!text-white"
            >
              {general.title}
            </Typography>
          </Stack>
          <div className="flex flex-col md:flex-row flex-1 w-full gap-4 md:gap-10">
            <Stack className="gap-4 flex-1">
              {firstHalf.map((item) => (
                <Row key={item.id} className="justify-between gap-2">
                  <Typography
                    fontVariant="md"
                    textAlign="left"
                    className="w-fit font-medium !text-white"
                  >
                    {item.text}
                  </Typography>
                  <StarRating
                    width={25}
                    height={25}
                    rating={item.averageRating}
                  />
                </Row>
              ))}
            </Stack>
            <Stack className="gap-4 flex-1">
              {secondHalf.map((item) => (
                <Row key={item.id} className="justify-between gap-2">
                  <Typography
                    fontVariant="md"
                    textAlign="left"
                    className="w-fit font-medium !text-white"
                  >
                    {item.text}
                  </Typography>
                  <StarRating
                    width={25}
                    height={25}
                    rating={item.averageRating}
                  />
                </Row>
              ))}
            </Stack>
          </div>
        </div>
        <Stack className="gap-10">
          {rates.map((item) => (
            <ReviewItem key={item.id} item={item} t={t} />
          ))}
          <Stack className="gap-4">
            {ratesInit.length - rates.length > 0 && (
              <button
                type="button"
                onClick={() => setRates(ratesInit)}
                className="bg-transparent text-clamp-sm border border-customGray-300 w-64 self-center text-customGray-700 px-6 py-3 rounded-[40px] global-hover uppercase"
              >
                {t('sp.readAllReviews', {
                  number: ratesInit.length - 3,
                })}
              </button>
            )}
            <LinkButton
              textTransform="uppercase"
              variant="primary-filled"
              label={t('sp.writeReview')}
              size="lg"
              className="w-fit self-center"
              onClick={openModalForm}
            />
          </Stack>
        </Stack>
      </div>
    </div>
  );
});

export default Reviews;
